import NavigationBar from './NavigationBar';

function Header() {
  return <NavigationBar />;
}

export default Header;
